import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { ShoppingBagIcon, ArrowRightIcon } from "@heroicons/react/24/outline"
import { navigate } from "aldoo-ra/Navigate"
import TextBundle from "aldoo-ra/CMS/text-bundle"

export default function ShoppingCartEmpty({ store }) {
  const texts = TextBundle({ id: "shopping_cart_empty" })

  return (
    <div className="flex flex-col items-center justify-center  bg-gray-50 rounded-[24px] py-16 px-4">
      <div className="bg-primary/10 rounded-full p-6 mb-6">
        <ShoppingBagIcon className="w-12 h-12 text-primary" />
      </div>

      <Typography 
        component="h1"
        variant="h4" 
        className="xl:!text-[42px] text-center text-text mb-8"
      >
        {texts?.title || "Your cart is empty"}
      </Typography>

      <Typography
        variant="txt"
        className="block text-center text-text max-w-[500px] mb-8"
      >
        {texts?.paragraph || "Looks like you haven't added anything to your cart yet. Discover our amazing products and start filling your cart with items you'll love!"}
      </Typography>

      <Button
        variant="secondary"
        onClick={() => {
          store.hideCart()
          navigate("/pricing")
        }}
      >
        {texts?.cta_start || "Start Shopping"}
        <ArrowRightIcon className="w-5 h-5 mt-1" />
      </Button>
    </div>
  )
}
